import { ExpansionDefinition } from '../types/expansions';
import { alienInvasionExpansion } from './on-mars/alien-invasion';
import { VINHOS_GAME_ID } from '../games/vinhos-deluxe/metadata';
import { marineWorldsExpansion } from './ark-nova/marine-worlds/expansion';

/** Optional Vinhos modules as shared ExpansionDefinitions (ready in 1.1). */
export const vinhosModuleExpansions: ExpansionDefinition[] = [
  {
    id: 'vinhos-experts',
    gameId: VINHOS_GAME_ID,
    title: 'Vinhos: Experts',
    shortTitle: 'Experts',
    description:
      '32 kafle ekspertów i trzy sposoby przygotowania. Pełna treść dostępna.',
    type: 'module',
    enabledByDefault: false,
    requiresBaseGame: true,
    selectionMode: 'toggle',
    contentStatus: 'ready',
  },
  {
    id: 'vinhos-islands',
    gameId: VINHOS_GAME_ID,
    title: 'Vinhos: Islands',
    shortTitle: 'Islands',
    description: 'Madera i Azory. Pełna treść dostępna.',
    type: 'module',
    enabledByDefault: false,
    requiresBaseGame: true,
    selectionMode: 'toggle',
    contentStatus: 'ready',
  },
  {
    id: 'vinhos-tasting-room',
    gameId: VINHOS_GAME_ID,
    title: 'Vinhos: Tasting Room',
    shortTitle: 'Tasting Room',
    description: 'Turyści i elementy deluxe. Pełna treść dostępna.',
    type: 'module',
    enabledByDefault: false,
    requiresBaseGame: true,
    selectionMode: 'toggle',
    contentStatus: 'ready',
  },
  {
    id: 'vinhos-connoisseur',
    gameId: VINHOS_GAME_ID,
    title: 'Vinhos: Connoisseur',
    shortTitle: 'Connoisseur',
    description:
      'Podwójne kafle, Filoksera i kafle oceanu. Pełna treść dostępna.',
    type: 'module',
    enabledByDefault: false,
    requiresBaseGame: true,
    selectionMode: 'toggle',
    contentStatus: 'ready',
  },
];

/** All known expansions, keyed for lookup by game. */
export const allExpansions: ExpansionDefinition[] = [
  alienInvasionExpansion,
  ...vinhosModuleExpansions,
  marineWorldsExpansion,
];

export function getExpansionsForGame(gameId: string): ExpansionDefinition[] {
  return allExpansions.filter((expansion) => expansion.gameId === gameId);
}

export function getExpansionById(
  expansionId: string
): ExpansionDefinition | undefined {
  return allExpansions.find((expansion) => expansion.id === expansionId);
}
